import React from 'react'
import { Cell, Icons } from '../../styles/styled-common'

export default class CheckCell extends React.PureComponent {
  render() {
    const { checked, children, ...props } = this.props
    return (
      <Cell {...props}>
        <span>
          {checked ? <Icons.Check /> : <Icons.Error />}
          {children}
        </span>
      </Cell>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cells/CheckCell.jsx